export default __webpack_public_path__ + "files/c45d349d2b2249e6a11460e51abffa0e.mp3";